/**
 * @ngdoc component
 * @name common.services:ItxErrorMessagesFct
 * @requires ngDialog
 * @description
 * Factory for managing messages coming from xhr requests and showing them in different parts of the app.
 */
(function () {

    'use strict';

    angular.module('itxApp.common')
        .service('ItxErrorMessagesFct', ItxErrorMessagesFct);

    ItxErrorMessagesFct.$inject = ['ngDialog'];


    function ItxErrorMessagesFct(ngDialog) {
        var messages = [], genericComponent = 'generic', defaultType = 'INFO';

        return {
            /**
             * Return all messages of given component and type.
             * if none especified uses default values
            */
            getAll: function (component, type) {
                var comp = component || genericComponent, tp = type || defaultType;
                return messages.filter(function (message) {
                    return message.component === comp && message.type === tp;
                }).map(function (item) {
                    return item.message;
                });
            },
            /**
             *  Return last message of given component and type.
             *  if none especified uses default values
             */
            getLast: function (component, type) {
                var comp = component || genericComponent, tp = type || defaultType,
                    lastMessage = messages.filter(function (message) {
                        return message.component === comp && message.type === tp;
                    })[0];
                return lastMessage ? lastMessage.message : null;
            },
            /**
             *  Adds a message of given component and type
             *  if none especified uses default values
             */
            add: function (message, component, type) {
                var comp = component || genericComponent, tp = type || defaultType,
                    messageComponent = {component: comp, type: tp, message: formatMessage(message)};
                messages.unshift(messageComponent);
            },
            /**
             *  Resets all messages of given component and type
             *  if none especified uses default values
             */
            reset: function (component, type) {
                var comp = component || genericComponent, tp = type || defaultType;
                messages = messages.filter(function (message) {
                    return message.component !== comp || message.type !== tp;
                });
            },
            /**
             *  Return if exists messages of given component and type
             *  if none especified uses default values
             */
            any: function (component, type) {
                var comp = component || genericComponent, tp = type || defaultType,
                    allMessages = messages.filter(function (message) {
                        return message.component === comp && message.type === tp;
                    });
                return allMessages.length > 0;
            },
            /**
             * Show generic dialog for errors
             * @param {string} message - If included then the dialog will show the message. If not included then
             * the dialog will show a common message with a link to contact support
             * @param {object} button { event: function call, text: button translation }
             */
            dialog: function (message, title, button) {
                var data =  {
                    message: message,
                    title: title
                };
                if(button){
                    data.onAction = button.event;
                    data.button = button.text;
                }
                
                ngDialog.open({
                    template: '<itx-error close-dialog="closeThisDialog()" message="ngDialogData.message" title="ngDialogData.title" button="ngDialogData.button" on-click-button="ngDialogData.onAction()"></itx-error>',
                    plain: true,
                    className: '  new-modal ma-modal-sm error-dialog ngdialog-theme-plain ',
                    showClose: true,
                    data: data 
                });
            }
        };

        //Private functions
        function formatMessage(message) {
            if (!message) {
                return '';
            }

            var text = '';

            if (typeof message === 'object') {
                text = message.errorMessage;
                if (message.errorKey && message.errorKey.indexOf('invalidCredentials') !== -1) {
                    text = text.replace('ItxStandardLogonCmd.input.email', 'email');
                    text = text.replace('ItxStandardLogonCmd.input.password', 'password');
                }
            } else {
                text = message;
                if (text.indexOf('CommonErrorFields.input.nif') !== -1) {
                    text = text.replace('CommonErrorFields.input.nif', 'nif');
                }
            }

            return text;
        }
    }

})();
